import { ATTESTATION_CATEGORY_COVERAGE } from 'utils/constants';

const isCategoryCovered = (attestationCategory, categoriesToTest) => (
  categoriesToTest.some((category) => ATTESTATION_CATEGORY_COVERAGE[category]?.includes(attestationCategory))
);

export const AttestationCategoryHelper = {
  isCategoryCovered
};
